import { WALLPAPER_WATERMARK_MODE } from '../constants/pro-settings';

export const extractWatermarkSettings = user => {
  return {
    watermarkMode: user?.pro_settings?.matched_photo_watermark_mode ?? null,
    faceblockMode: user?.pro_settings?.faceblock_mode ?? null,
    faceblockCustomIconAssetImage:
      user?.pro_settings?.faceblock_custom_icon_asset_image ?? '',
    wallpaperWatermarkMode:
      user?.pro_settings?.wallpaper_watermark_settings?.mode ??
      WALLPAPER_WATERMARK_MODE.TEXT,
    wallpaperCustomText:
      user?.pro_settings?.wallpaper_watermark_settings?.text?.custom_text ??
      'waldo',
    wallpaperFontSize:
      user?.pro_settings?.wallpaper_watermark_settings?.text?.font_size ?? '50',
    wallpaperAssetImage:
      user?.pro_settings?.wallpaper_watermark_settings?.image?.asset_image ??
      {},
  };
};
